module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-group"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Home"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "home-product"
  }, [_c('div', {
    staticClass: "home-product-item1"
  }, [_c('div', {
    staticClass: "home-product-img"
  }, [_c('router-link', {
    staticClass: "font_small",
    attrs: {
      "to": {
        path: '/product/mogos',
        query: {
          id: 1
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/mogos_banner_card.png")
    }
  }), _vm._v(" "), (this.Homelang == 'en') ? _c('img', {
    staticClass: "home_icon",
    attrs: {
      "src": require("../../assets/home/new_home/free_en@2x.png")
    }
  }) : _c('img', {
    staticClass: "home_icon",
    attrs: {
      "src": require("../../assets/home/new_home/free_sc@2x.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "home-product-item1-1"
  }, [_c('div', {
    staticClass: "home_kownMore"
  }, [_c('div', {
    staticClass: "home_kownMore_content"
  }, [_c('router-link', {
    staticClass: "font_small",
    attrs: {
      "to": {
        path: '/product/mogos',
        query: {
          id: 1
        }
      }
    }
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t('home_mogos')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "font_margin"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('home_mogos_content')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "line-through",
      "color": "red"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#1f2d3d"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_mogos_originalprice')) + ":$22")])])])]), _vm._v(" "), _c('button', {
    staticClass: "font_small",
    staticStyle: {
      "width": "150px",
      "height": "40px"
    }
  }, [_c('router-link', {
    staticClass: "font_small",
    attrs: {
      "to": {
        path: '/product/mogos',
        query: {
          id: 1
        }
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('home_mogos_get')) + "\n                            ")])], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-product2"
  }, [_c('div', {
    staticClass: "home-product-item2"
  }, [_c('div', {
    staticClass: "home-product-item2-1"
  }, [_c('div', {
    staticClass: "home_kownMore"
  }, [_c('div', {
    staticClass: "home_kownMore_content"
  }, [_c('router-link', {
    staticClass: "font_small",
    attrs: {
      "to": {
        path: '/product/s1',
        query: {
          id: 3
        }
      }
    }
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('home_mogos1')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "font_margin"
  }, [_c('p', {
    staticClass: "font_mid",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_mogos1_content')))])]), _vm._v(" "), _c('a', {
    staticClass: "font_small"
  }, [_c('router-link', {
    staticClass: "font_small",
    attrs: {
      "to": {
        path: '/product/s1',
        query: {
          id: 3
        }
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('Services_mainpage_remain_to_be_solved')) + " "), _c('Icon', {
    attrs: {
      "type": "arrow-right-c"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "home-product-item2-2"
  }, [_c('div', {
    staticClass: "home_kownMore"
  }, [_c('div', {
    staticClass: "home_kownMore_content"
  }, [_c('router-link', {
    staticClass: "font_small",
    attrs: {
      "to": {
        name: 'iVoice'
      }
    }
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('home_ivoice')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "font_margin"
  }, [_c('p', {
    staticClass: "font_mid",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_ivoice_content')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('home_ivoice_content1')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "font_small",
    attrs: {
      "to": {
        name: 'iVoice'
      }
    }
  }, [_c('a', {
    staticClass: "font_small"
  }, [_vm._v(_vm._s(_vm.$t('Services_mainpage_remain_to_be_solved')) + " "), _c('Icon', {
    attrs: {
      "type": "arrow-right-c"
    }
  })], 1)])], 1)])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home_information"
  }, _vm._l((_vm.meida), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "home_information_group"
    }, [_c('h1', [_vm._v(_vm._s(_vm.$t('footer_media')))]), _vm._v(" "), _c('div', {
      staticClass: "home_information_img"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "home_information_content"
    }, [_c('h1', {
      staticClass: "font_big",
      on: {
        "click": function($event) {
          _vm.more(item.cms_id)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                ")]), _vm._v(" "), _c('p', {
      staticClass: "font_small",
      staticStyle: {
        "text-overflow": "ellipsis",
        "overflow": "hidden",
        "display": "-webkit-box",
        "-webkit-line-clamp": "3",
        "-webkit-box-orient": "vertical"
      },
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "font_small",
      on: {
        "click": function($event) {
          _vm.more(item.cms_id)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('Services_mainpage_remain_to_be_solved')) + " "), _c('Icon', {
      attrs: {
        "type": "arrow-right-c"
      }
    })], 1)])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-107fd6d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = 781
// module chunks = 0